export const gtagClickTracking = (eventCategory: string, eventName: string) => {
  window.gtag('event', '버튼클릭', {
    event_category: eventCategory,
    event_label: eventName,
  });
};
